module.exports = __webpack_public_path__ + "img/weddings_14_V.f74457b1.jpg";